import React, {useEffect, useState} from "react";
import "./OnlineSearch.scss";
import {useHistory} from "react-router-dom";
import {useBasket, useDispatchBasket} from "../../hooks";
import {StoreData} from "../../Pages/StoreDetail/StoreDetailServices";
import {StoreOnlineSearch, StoreOnlineSearchPAge} from "./OnlineSearchService";
import {AddBasket, RemoveBasket} from "../OnlineAddress/OnlineAddressService";
import Rodal from "rodal";
import {RangeSlider, SliderLabel} from '@progress/kendo-react-inputs';
import '@progress/kendo-theme-default/dist/all.css';
import useWindowDimensions from "../../hooks/useWindowDimensions";
import {openNotificationWithIcon} from "../../Services";
import { MenuOutlined } from '@ant-design/icons';
import { Button, Drawer } from 'antd';

let selBra = []

function BasketAddRemoveSub({item}) {

    //hooks
    const setBasket = useDispatchBasket();
    const basket = useBasket();
    const history = useHistory();

    //states
    const [loading, set_loading] = useState(false)


    useEffect(() => {

    }, [])

    const addToBasket = async (pId) => {
        let merchantId = window.location.pathname.split("/")[2]
        const response = await AddBasket(merchantId, pId,item)
        console.log("Add : ", response)
    }

    const removeFromBasket = async (pId) => {
        let merchantId = window.location.pathname.split("/")[2]
        const response = await RemoveBasket(merchantId, pId)
        console.log("Remove : ", response)
    }

    //functions
    const inc = async () => {
        if (loading) {
            return
        }
        try {
            set_loading(true)
            //ADD API
            await addToBasket(item.uid);
            let merchantId = window.location.pathname.split("/")[2]
            openNotificationWithIcon('success',item,history,merchantId)
            set_loading(false)
        } catch (e) {
            set_loading(false)
            return;
        }
        //--------------------------------- Context Change ----------------------------------------------
        //check exist in basket
        if (basket.find(product => product.product.uid === item.uid)) {
            //exist
            let filter = basket.map(pro => pro.product.uid === item.uid ? {...pro, count: pro.count + 1} : pro)
            //context change
            setBasket(filter);
            //storage change
            localStorage.setItem("basket", JSON.stringify(filter));
        } else {
            //not exist

            //context change
            setBasket(oldArray => [...oldArray, {product: item, count: 1}]);
            //storage change
            localStorage.setItem("basket", JSON.stringify([...basket, {product: item, count: 1}]));
        }


    }

    const dec = async () => {
        if (loading) {
            return
        }
        try {
            set_loading(true)
            //Remove API
            await removeFromBasket(item.uid)
            set_loading(false)
        } catch (e) {
            set_loading(false)
            return;
        }

        //--------------------------------- Context Change ----------------------------------------------
        //check exist in basket
        let find = basket.find(product => product.product.uid === item.uid);
        if (find) {
            //exist
            if (find.count > 0) {
                //exist
                let filter = basket.map(pro => pro.product.uid === item.uid ? {...pro, count: pro.count - 1} : pro)

                if (find.count === 1) {
                    //context change
                    setBasket(basket.filter(product => product.product.uid !== item.uid))
                    //storage change
                    localStorage.setItem("basket", JSON.stringify(basket.filter(product => product.product.uid !== item.uid)));
                } else {
                    //context change
                    setBasket(filter);
                    //storage change
                    localStorage.setItem("basket", JSON.stringify(filter));
                }
            } else {
                //context change
                setBasket(basket.filter(product => product.product.uid !== item.uid))
                //storage change
                localStorage.setItem("basket", JSON.stringify(basket.filter(product => product.product.uid !== item.uid)));
            }
        }


    }

    const remove = () => {
        //--------------------------------- Context Change ----------------------------------------------
        setBasket(basket.filter(product => product.product.uid !== item.uid))
        //--------------------------------- Local Storage Change ----------------------------------------------
        setTimeout(() => {
            localStorage.setItem("basket", JSON.stringify(basket));
        }, 500)
    }

    const checkCount = () => {
        let basket_count = basket.find(product => product.product.uid === item.uid);
        if (basket_count) {
            return basket_count.count;
        }
        return 0;
    }

    return (
        <div className="add-remove-section-sub">
            {checkCount() > 0 ? <>
                <i className="fa fa-minus" onClick={dec}></i>
                <span className="product-count-number">
                    {!loading ? checkCount() : <i className="fa fa-spinner fa-spin"></i>}
                </span>
            </> : null}
            {/*{item.stock > checkCount() ? <i className="fa fa-plus" onClick={inc}></i> : null}*/}
            {item.stock>checkCount()?<i className="fa fa-plus" onClick={inc}></i>:<span className="stock-over">ناموجود</span>}
        </div>
    )
}

function numberWithCommas(x) {
    if (x === 0) {
        return 0
    }
    if (x) {
        return x ? x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") : 0;
    }

    return "-"

}

function OnlineSubCatCard({cat, merchantId}) {
    //hooks
    const history = useHistory();

    return (
        <div className="online-sub-categories-item">
            <BasketAddRemoveSub item={cat}/>
            {/*<div className="add-re-section">*/}
            {/*    /!*<i className="fa fa-plus"></i>*!/*/}
            {/*    <div className="count">1</div>*/}
            {/*    <i className="fa fa-trash"></i>*/}
            {/*</div>*/}
            <div className="info-section" onClick={() => {
                history.push(`/online-store-product/${merchantId}/${cat.uid}`)
            }}>
                <span>{cat.name}</span>
                <div className="price-section">
                    {cat.price_original!==cat.price? <span style={{direction: "rtl"}} className="original-price">{numberWithCommas(cat.price_original)} </span>:null}
                    <span style={{direction: "rtl"}} className="price">{numberWithCommas(cat.price)} ریال </span>
                </div>
            </div>
            <div className="img-section" onClick={() => {
                history.push(`/online-store-product/${merchantId}/${cat.uid}`)
            }}>
                <img src={cat.image} alt=""/>
                {cat && cat.discount_percentage!==0?
                    <div className="off">
                        {cat.discount_percentage + " % "}
                    </div>:null
                }
            </div>
        </div>
    )
}


function OnlineSearch({back = null, merchantId = null,direct=false}) {


    //hooks
    const history = useHistory();
    const basket = useBasket();

    console.log("SEARCH : ", merchantId)

    //states
    const [merchant, set_merchant] = useState(null)
    const [searchMode, set_searchMode] = useState(false)
    const [results, set_results] = useState([])
    const [search, set_search] = useState([])
    const [pp, set_pp] = useState(1)

    const [filterModal, set_filterModal] = useState(false)
    const [sortModal, set_sortModal] = useState(false)
    const [sortObj, set_sortObj] = useState({label: "جدیدترین", value: "ordering=-created"})
    const [sortList, set_sortList] = useState([
        {label: "پرتخفیف ترین", value: "discount_descending=true"},
        {label: "ارزانترین", value: "ordering=price"},
        {label: "گرانترین", value: "ordering=-price"},
        {label: "جدیدترین", value: "ordering=-created"},
    ])

    const [startPrice, set_startPrice] = useState(0)
    const [endPrice, set_endPrice] = useState(50000000)
    const [maxPrice, set_maxPrice] = useState(50000000)

    const [rangSwitch, set_rangSwitch] = useState(true)
    const [available, set_available] = useState(false)

    const [brands, set_brands] = useState([])
    const [checkListState,set_checkListState] = useState(true)


    const resetSortFilter = async () => {
        set_sortObj({label: "جدیدترین", value: "ordering=-created"})
        await set_endPrice(maxPrice)
        await set_startPrice(0)
        set_rangSwitch(false)
        setTimeout(() => {
            set_rangSwitch(true)
            set_available(false)
            selBra = []
            set_checkListState(false)
            const input = document.getElementById("searci");
            doReset(input.value)
            set_filterModal(false)
        }, 1000)
    }


    const calculateBasket = () => {
        let count = 0;
        basket.forEach(item => {
            count += item.count
        })
        return count
    }

    useEffect(() => {
        getMerchant()
    }, [merchantId])

    const getMerchant = async () => {
        if (merchantId && typeof merchantId === "string") {
            try {
                const response = await StoreData(merchantId)
                set_merchant(response.data);
            } catch (e) {
                console.log(e)
            }
        }

    }

    let page = 1;

    const HandleScroll = async () => {
        const elm = document.getElementById("searchList");
        if (elm.scrollTop + elm.clientHeight == elm.scrollHeight) {
            const input = document.getElementById("searci");
            console.log("page: ",)
            paginate(input.value)
        }
    }


    useEffect(() => {
        //handle scroll arrived to Top
        const elm = document.getElementById("searchList");
        if (searchMode && elm) {
            elm.addEventListener('scroll', HandleScroll);
        } else {
            if (elm) {
                elm.removeEventListener('scroll', HandleScroll); // Remove Scroll Event Listener
            }
        }

    }, [searchMode])

    const paginate = async (wo) => {
        console.log("Word FF : ", wo)
        try {
            window.hh = window.hh + 1;
            page = page + 1;
            let response = await StoreOnlineSearchPAge(merchantId, wo, window.hh, sortObj.value, startPrice, endPrice, available,brandQuery());
            console.log("Searched : ", response);
            if (response.data.results.length > 0) {
                set_results((list) => [...list, ...response.data.results]);
                if(response.data.brands){
                    set_brands(response.data.brands)
                }
            } else {
                window.hh = window.hh - 1;
                page = page - 1;
            }
        } catch (e) {
            console.log(e);
            window.hh = window.hh - 1;
            page = page - 1;
        }
    }

    const doReset = async (value) => {
        window.hh = 1;
        page = 1;
        set_search(value)
        console.log("word : ", value);
        if (value.length > 2) {
            set_searchMode(true);
            try {
                let response = await StoreOnlineSearch(merchantId, value, 1, "ordering=-created", 0, maxPrice, false,brandQuery());
                console.log("Searched : ", response);
                set_checkListState(true)
                set_results(response.data.results);
                if(response.data.brands) {
                    set_brands(response.data.brands)
                }
                const elm = document.getElementById("searchList");
                elm.scrollTo({left: 0, top: 0});
            } catch (e) {
                console.log(e);
            }
        }

        if (value.length < 1) {
            set_searchMode(false);
            set_results([])
        }
    }

    const brandQuery = () =>{
        let brandQuery = "";
        selBra.forEach(item=>{brandQuery+="&brand__uid="+item.uid})
        return brandQuery;
    }


    const doSearch = async (value) => {
        window.hh = 1;
        page = 1;
        set_search(value)
        console.log("word : ", value);
        if (value.length > 2) {
            set_searchMode(true);
            try {
                let response = await StoreOnlineSearch(merchantId, value, 1, sortObj.value, startPrice, endPrice, available,brandQuery());
                console.log("Searched : ", response);
                set_results(response.data.results);
                if(response.data.brands) {
                    set_brands(response.data.brands)
                }
                const elm = document.getElementById("searchList");
                elm.scrollTo({left: 0, top: 0});
            } catch (e) {
                console.log(e);
            }
        }

        if (value.length < 1) {
            set_searchMode(false);
            set_results([])
        }
    }

    const doFilter = () => {

    }

    const addToBrandsFilter = (item) =>{
        console.log("brand add : ",item);
        // set_selectedBrands(list=>[...list,item])
        selBra = [...selBra,item]
    }
    const removeFromBrandsFilter = (brand) =>{
        console.log("brand remove : ",brand);
        selBra = selBra.filter(item => item.uid !== brand.uid)
        // set_selectedBrands(selectedBrands.filter(item => item.uid !== brand.uid))
    }

    const checkExistBrand = (uid) => {
        let res = selBra.find(item => item.uid === uid)
        return res ? true : false;
    }

    const BrandsItem = ({brand,add,remove})=>{

        const [state , set_state] = useState(false);

        return(
            <div className="modal-filter-list-item">
                <span>{brand.name}</span>
                <input type="checkbox" checked={state} name="" id=""
                       onClick={()=>{
                           set_state(!state)
                           if(!state){
                               add(brand)
                           }else{
                               remove(brand)
                           }
                       }}
                />
            </div>
        )
    }

    const { height, width,mobileWidth } = useWindowDimensions();

    const [open, setOpen] = useState(false);
    const showDrawer = () => {
        setOpen(true);
    };
    const onClose = () => {
        setOpen(false);
    };

    return (
        <div>
            <Drawer onClose={onClose} visible={open} closable={false}>
                <div className="merchant-menu">
                    <div className="merchant-menu-item" onClick={e=>{
                        history.push("/home")
                        onClose()
                    }}>
                        <span>خانه</span>
                        <img src="/navbar/home_icon.svg" alt=""/>
                    </div>

                    <div className="merchant-menu-item" onClick={e=>{
                        history.push(`/online-store/${merchantId}`)
                        onClose()
                    }}>
                        <span>فروشگاه</span>
                        <img src="/navbar/_store_icon.svg" alt=""/>
                    </div>
                    <div className="merchant-menu-item"  onClick={e=>{
                        history.push(`/profile`)
                        onClose()
                    }}>
                        <span>پروفایل</span>
                        <img src="/navbar/gift_icon.svg" alt=""/>
                    </div>
                </div>
            </Drawer>
            <Rodal
                customStyles={{
                    height: 'auto',
                    bottom: 'auto',
                    zIndex: 2001,
                    top: '50%',
                    transform: 'translateY(-50%)',
                    width: '300px'
                }}
                closeMaskOnClick={false}
                showCloseButton={false}
                animation={"zoom"} visible={filterModal} onClose={() => set_filterModal(false)}>
                <div className="modal-filter-container">
                    <div className="approve_btn" onClick={() => {
                        const input = document.getElementById("searci");
                        doSearch(input.value)
                        set_filterModal(false)
                    }}>
                        <span>مشاهده</span>
                    </div>
                    <div className="modal-filter-item" style={{marginTop: 0}}>
                        <div className="modal-filter-label" style={{marginBottom: 20, marginTop: 20}}>
                            <span>محدوده قیمت </span>
                            <i className="fa fa-star"></i>
                        </div>
                        <div className="choose-price">
                            <span>{numberWithCommas(startPrice)} ریال </span>
                            <span>تا</span>
                            <span>{numberWithCommas(endPrice)} ریال </span>
                        </div>
                        {rangSwitch ? <RangeSlider
                            defaultValue={{start: startPrice, end: endPrice}}
                            step={1}
                            min={0}
                            startTabIndex={0}
                            style={{width: '100%'}}
                            max={maxPrice}
                            onChange={(e) => {
                                set_startPrice(e.value.start.toFixed())
                                set_endPrice(e.value.end.toFixed())
                            }}
                        >
                            {/*{[0,  100].map((perc, i) => (*/}
                            {/*    <SliderLabel*/}
                            {/*        key={i}*/}
                            {/*        position={perc}*/}
                            {/*    >*/}
                            {/*        {perc.toString()}*/}
                            {/*    </SliderLabel>*/}
                            {/*))}*/}
                        </RangeSlider> : null}
                    </div>

                    {brands.length > 0 ? <div className="modal-filter-item">
                        <div className="modal-filter-label">
                            <span>برندها</span>
                            <i className="fa fa-star"></i>
                        </div>
                        {checkListState?<div className="modal-filter-list">
                            {brands.map(brand => {
                                return (
                                    // <BrandsItem remove={removeFromBrandsFilter} add={addToBrandsFilter} brand={brand}/>
                                    <div className="modal-filter-list-item">
                                        <span>{brand.name}</span>
                                        <input type="checkbox"  name="" id=""
                                               onClick={()=>{
                                                   if(!checkExistBrand(brand.uid)){
                                                       addToBrandsFilter(brand)
                                                   }else{
                                                       removeFromBrandsFilter(brand)
                                                   }
                                               }}
                                        />
                                    </div>
                                )
                            })}
                        </div>:null}
                    </div> : null}

                    {/*item*/}


                    <div className="modal-filter-item">
                        <div className="modal-filter-label">
                            <span>موجود بودن</span>
                            <i className="fa fa-list"></i>
                        </div>
                        <div className="modal-filter-list">
                            <div className="modal-filter-list-item">
                                <span>موجود</span>
                                <input
                                    onClick={() => {
                                        set_available(!available)
                                    }}
                                    type="checkbox" name="" id="" checked={available}/>
                            </div>
                            {/*<div className="modal-filter-list-item">*/}
                            {/*    <span>ناموجود</span>*/}
                            {/*    <input type="checkbox" name="" id=""/>*/}
                            {/*</div>*/}
                        </div>
                    </div>

                </div>


            </Rodal>

            <Rodal
                customStyles={{
                    height: 'auto',
                    bottom: 'auto',
                    zIndex: 2001,
                    top: '50%',
                    transform: 'translateY(-50%)',
                    width: '300px'
                }}
                closeMaskOnClick={false}
                showCloseButton={false}
                animation={"zoom"} visible={sortModal} onClose={() => set_sortModal(false)}>
                <div className="approve_btn" onClick={
                    () => {
                        const input = document.getElementById("searci");
                        doSearch(input.value)
                        set_sortModal(false)
                    }
                }>
                    <span>مشاهده</span>
                </div>
                <div className="sort-modal-container">
                    <div className="sort-modal-title">
                        <span>مرتب سازی </span>
                        <i className="fa fa-sort"></i>
                    </div>
                    <div className="sort-modal-list">
                        {sortList.map(item => {
                            return (
                                <div className="sort-modal-list-item">
                                    <span>{item.label}</span>
                                    <input type="radio" name="sort"
                                           checked={item.label === sortObj.label ? true : false} id="" onClick={() => {
                                        set_sortObj(item)
                                    }}/>
                                </div>
                            )
                        })}
                    </div>
                </div>

            </Rodal>


            <div>

            </div>
            <div className="online-search-container" style={{width:mobileWidth?mobileWidth:document?.getElementById('mobile-sec')?.clientWidth}}>

                {!searchMode ? <i className="fa fa-arrow-left" onClick={() => {
                    if (back) {
                        back()
                    } else {
                        if(!direct){
                            history.goBack();
                        }else {
                            history.push("/home");
                        }
                    }
                }}/> : <i className="fa fa-close" onClick={() => {
                    set_searchMode(false);
                    set_results([])
                    set_search("");
                }}
                ></i>}




                <div className="online-search-input">
                    <input
                        autoComplete="new-password"
                        value={search}
                        style={{textAlign: 'center'}}
                        onChange={(e) => {
                            doSearch(e.target.value)
                        }
                        }
                        type="text" name="" id="searci" placeholder={`از  ${merchant ? merchant.name : " "} چی میخوای ؟`}/>
                    <i className="fa fa-search"></i>
                </div>





                <i className="fa fa-shopping-cart" onClick={() => {
                    history.push("/online-store-basket/" + merchantId)
                }}>
                    <span className="cart-badg">{calculateBasket()}</span>
                </i>

                <div className="burger-merchant-menu" onClick={showDrawer}>
                    <MenuOutlined  style={{fontSize:20}}/>
                </div>



            </div>

            {searchMode ? <div className="filter-box" style={{width:mobileWidth?mobileWidth:document?.getElementById('mobile-sec')?.clientWidth}}>
                <div className="filter-box-row">
                    <div className="filter-box-item" onClick={() => {
                        set_sortModal(true)
                    }}>
                        <span>{sortObj.label}</span>
                        <i className="fa fa-sort"></i>
                    </div>
                    <div className="filter-box-item" onClick={() => {
                        set_filterModal(true)
                    }}>
                        <span>فیلتر</span>
                        <i className="fa fa-sliders"></i>
                    </div>

                    <span className="clear_filters" onClick={() => {
                        resetSortFilter()
                    }}>
                      پاک کردن
                  </span>
                </div>
            </div> : null}


            {searchMode ? <div id="searchList" className="online-search-results" style={{width:mobileWidth?mobileWidth:document?.getElementById('mobile-sec')?.clientWidth}}>
                {results.map(item => {
                    return (
                        <OnlineSubCatCard merchantId={merchantId} cat={item}/>
                    )
                })}
            </div> : null}
        </div>
    )
}

export {OnlineSearch};
